/*
 * ----------------------------------------------------------------------------
 * TIB WIZARD (prototype) — 3-step guided flow around the Teeinblue widget
 * ----------------------------------------------------------------------------
 * PDP shows only a "Jetzt personalisieren" button. Click opens a guided pop-up:
 *   1) Größe wählen       -> real .tee-variants
 *   2) Foto hochladen     -> real #teeFormInputs; picking a file opens TIB's cropper
 *   3) Zuschnitt bestätigen -> shows the cropped result; "Bestätigen" ends the flow
 * Confirming returns the shopper to the NORMAL PDP (full customizer: Vorschau /
 * In den Warenkorb / Rahmen / price / payments) where Teeinblue renders the result.
 *
 * We never rebuild Teeinblue — we only orchestrate its real DOM:
 *   - <form.tee-form-wrapper> > #tee-artwork-form.tee-campaign holds every block.
 *   - We MOVE THE WHOLE <form> (a unit) into a body-level overlay so the form
 *     stays intact (Add-to-Cart keeps working). The Vue root is never touched.
 *   - Step VISIBILITY is done in CSS (snippets/tib-wizard.liquid), keyed off
 *     data-tib-step on the card, with !important. That is the critical bit:
 *     Teeinblue is a Vue app that re-renders on every change and wipes inline
 *     styles — but it cannot beat our !important stylesheet rules. JS only flips
 *     the attribute; it never sets display on TIB nodes.
 *   - The cropper (.tee-cropper in .vm--container.tee-dialog, z-index 999) is
 *     re-parented to <body> on open so it sits above our overlay (z-index 900).
 *   - Flow is signal-based (poll the cropper's visibility), independent of how
 *     vue-js-modal adds/removes nodes.
 *
 * Labels (per market) come from window.__tibWizard (snippets/tib-wizard.liquid).
 */
(function () {
  'use strict';

  if (window.__tibWizardBooted) return;
  window.__tibWizardBooted = true;

  var CFG = window.__tibWizard || {};
  var L = CFG.labels || {};

  // A/B activation flag (mirrors snippets/cart-drawer-ab.liquid): the wizard is dormant
  // in the theme and only turns on for the experiment's variant. Control keeps the normal
  // Teeinblue customizer. QA override: append ?ab_wizard=on to any URL.
  function abWizardActive() {
    try { if (window.__AB_TIB_WIZARD === 'on') return true; } catch (e) {}
    try { if (/[?&]ab_wizard=on\b/.test(window.location.search)) return true; } catch (e) {}
    return false;
  }

  ready(function () {
    waitFor(function () {
      var f = document.querySelector('#tee-artwork-form');
      // Require the photo upload too: the wizard only fits photo-upload + crop
      // campaigns. Text/name/map campaigns (no file input) never activate it.
      return f && f.querySelector('#teeFormActions') && f.querySelector('input[type=file]') ? f : null;
    }, 20000, function (artwork) {
      if (!artwork) return;            // not a photo TIB campaign / TIB failed to render — no-op
      if (!abWizardActive()) return;   // A/B control group -> leave the normal customizer
      try { init(artwork); } catch (e) { if (window.console) console.warn('[tib-wizard]', e); }
    });
  });

  function init(artwork) {
    var docEl = document.documentElement;
    // Scope our global-ish cropper CSS to variant users only (keeps the A/B control's
    // native cropper untouched).
    docEl.classList.add('ab-tib-wizard-active');
    var formWrap = artwork.closest('form') || artwork.parentNode;
    var origParent = formWrap.parentNode;
    var origNext = formWrap.nextSibling;
    var current = 0;
    var finishing = false;
    var cropTimer = null;
    var renderTimer = null;
    var deletionObserver = null;

    // Build the step list for THIS product. A "details" step (name) is inserted before
    // the photo step ONLY when the customizer actually has a visible, fillable TEXT input
    // (a real name to type) — not just any non-photo .tee-field, which could be a hidden
    // layer or a non-text field. Generic: works for every product with no per-product tuning.
    var teeInputs = artwork.querySelector('#teeFormInputs');
    function isShown(x) { try { return !!(x && (x.offsetWidth || x.offsetHeight || x.getClientRects().length)); } catch (e) { return false; } }
    var hasDetails = false;
    if (teeInputs) {
      var _groups = teeInputs.querySelectorAll('.tee-field:not(.tee-field--photo):not(.sr-only)');
      for (var _gi = 0; _gi < _groups.length; _gi++) {
        var _inp = _groups[_gi].querySelector('input[type="text"], input:not([type]), textarea');
        if (_inp && _inp.type !== 'hidden' && isShown(_groups[_gi]) && isShown(_inp)) { hasDetails = true; break; }
      }
    }
    // A "size" step only makes sense when there's a real, VISIBLE variant choice to make
    // (e.g. poster size). Products without one (e.g. one-size beach towels — no visible size
    // option, colour is sr-only) skip it. Generic; no per-product tuning.
    var hasSize = false;
    var _variants = artwork.querySelector('.tee-variants');
    if (_variants) {
      var _opts = _variants.querySelectorAll('.tee-option:not(.sr-only)');
      for (var _oi = 0; _oi < _opts.length; _oi++) {
        if (isShown(_opts[_oi]) && _opts[_oi].querySelectorAll('.tee-radio, input[type="radio"], option').length >= 2) { hasSize = true; break; }
      }
    }
    var STEPS = [];
    if (hasSize) STEPS.push({ key: 'size', title: L.step_size || 'Größe wählen' });
    if (hasDetails) STEPS.push({ key: 'details', title: L.step_name || 'Name eingeben' });
    STEPS.push({ key: 'photo', title: L.step_photo || 'Foto hochladen' });
    STEPS.push({ key: 'crop', title: L.step_crop || 'Vorschau wird erstellt' });
    function stepIndex(key) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i].key === key) return i; return -1; }
    // First required non-photo field that is still empty (for the details step's "Weiter").
    function firstEmptyRequired() {
      var groups = formWrap.querySelectorAll('#teeFormInputs .tee-field:not(.tee-field--photo):not(.sr-only)');
      for (var i = 0; i < groups.length; i++) {
        var inputs = groups[i].querySelectorAll('input, textarea, select');
        for (var j = 0; j < inputs.length; j++) {
          var f = inputs[j];
          if ((f.required || f.getAttribute('aria-required') === 'true') && !String(f.value || '').trim()) return f;
        }
      }
      return null;
    }

    // --- Trigger on the PDP (shown while the customizer is tucked away) ---
    var trigger = el('button', 'tib-wizard-trigger');
    trigger.type = 'button';
    trigger.textContent = L.personalize || 'Jetzt personalisieren';
    origParent.insertBefore(trigger, formWrap);

    // --- Overlay + card chrome ---
    var overlay = el('div', 'tib-wizard-overlay');
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="tib-wizard-backdrop" data-tib-close></div>' +
      '<div class="tib-wizard-card" role="dialog" aria-modal="true">' +
        '<button type="button" class="tib-wizard-x" data-tib-close aria-label="' + esc(L.close || 'Schließen') + '">&times;</button>' +
        '<div class="tib-wizard-head">' +
          '<ol class="tib-wizard-dots"></ol>' +
          '<p class="tib-wizard-title"></p>' +
        '</div>' +
        '<div class="tib-wizard-body"></div>' +
        '<div class="tib-wizard-foot">' +
          '<button type="button" class="tib-wizard-back">' + esc(L.back || 'Zurück') + '</button>' +
          '<button type="button" class="tib-wizard-next"></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    var card    = overlay.querySelector('.tib-wizard-card');
    var bodyEl  = overlay.querySelector('.tib-wizard-body');
    var dotsEl  = overlay.querySelector('.tib-wizard-dots');
    var titleEl = overlay.querySelector('.tib-wizard-title');
    var backBtn = overlay.querySelector('.tib-wizard-back');
    var nextBtn = overlay.querySelector('.tib-wizard-next');
    // Only split name-vs-photo (and hide non-photo fields in the photo step) when a real
    // name step exists — otherwise a visible non-text field must NOT be hidden/lost.
    if (hasDetails) card.setAttribute('data-tib-details', '1');

    // Move the whole <form> into the card (once). PDP now shows only the trigger.
    bodyEl.appendChild(formWrap);

    /* ---- step rendering (visibility is pure CSS, keyed off data-tib-step) ---- */
    function render() {
      card.removeAttribute('data-tib-phase');
      card.setAttribute('data-tib-step', STEPS[current].key);
      titleEl.textContent = STEPS[current].title;

      dotsEl.innerHTML = '';
      STEPS.forEach(function (_s, i) {
        var li = el('li', 'tib-wizard-dot' + (i === current ? ' is-active' : '') + (i < current ? ' is-done' : ''));
        li.textContent = String(i + 1);
        dotsEl.appendChild(li);
      });

      backBtn.style.visibility = current === 0 ? 'hidden' : '';

      var key = STEPS[current].key;
      if (key === 'size' || key === 'details') {
        // navigational steps -> "Weiter"
        nextBtn.style.display = '';
        nextBtn.textContent = L.next || 'Weiter';
        nextBtn.setAttribute('data-action', 'next');
        nextBtn.disabled = false;
      } else if (key === 'photo' && formWrap.querySelector('#teeFormInputs img.tee-photo-image')) {
        // A photo is already present (e.g. a persisted session) — normally the photo step
        // advances by picking a file (-> cropper), but with an existing photo the shopper
        // would be stuck. Offer "Weiter" to proceed with the current photo.
        nextBtn.style.display = '';
        nextBtn.textContent = L.next || 'Weiter';
        nextBtn.setAttribute('data-action', 'finish');
        nextBtn.disabled = false;
      } else {
        // fresh photo step (upload drives) / crop step (cropper drives) -> no button here
        nextBtn.style.display = 'none';
      }
      bodyEl.scrollTop = 0;
    }

    function goto(i) { current = Math.max(0, Math.min(STEPS.length - 1, i)); render(); }

    function open() {
      finishing = false;
      trigger.style.display = '';
      goto(0);
      overlay.removeAttribute('hidden');
      docEl.classList.add('tib-wizard-lock');
      startCropperWatch();
    }

    function stopWatch() {
      if (cropTimer) { clearInterval(cropTimer); cropTimer = null; }
      if (renderTimer) { clearInterval(renderTimer); renderTimer = null; }
    }

    // X / backdrop / Esc: close the pop-up, leave the PDP as it was (button only).
    function cancel() {
      stopWatch();
      overlay.setAttribute('hidden', '');
      docEl.classList.remove('tib-wizard-lock');
    }

    // Crop confirmed: close pop-up, restore the full customizer on the PDP so TIB
    // renders the mockup full-size there.
    function finish() {
      if (finishing) return;
      finishing = true;
      stopWatch();
      overlay.setAttribute('hidden', '');
      docEl.classList.remove('tib-wizard-lock');
      if (origNext && origNext.parentNode === origParent) origParent.insertBefore(formWrap, origNext);
      else origParent.appendChild(formWrap);
      trigger.style.display = 'none';
      watchForDeletion();
      // Let the layout settle after moving the form back, then reveal the preview.
      setTimeout(scrollToPreview, 60);
    }

    /* Back to the initial state: tuck the customizer away into the (hidden) card, show
       the "personalize" trigger again. Used when the shopper deletes their photo or
       hits "reset". */
    function resetToInitial() {
      if (deletionObserver) { deletionObserver.disconnect(); deletionObserver = null; }
      stopWatch();
      finishing = false;
      current = 0;
      card.removeAttribute('data-tib-phase');
      overlay.setAttribute('hidden', '');
      docEl.classList.remove('tib-wizard-lock');
      bodyEl.appendChild(formWrap);   // customizer back into the hidden card
      trigger.style.display = '';
    }

    /* Feature 1: once personalized, watch for the shopper deleting their photo (TIB's
       "×" / .tee-photo-clear removes #teeFormInputs img.tee-photo-image). Debounced so
       "choose another image" (which briefly clears then reopens the cropper) doesn't
       trigger a reset. */
    function watchForDeletion() {
      if (deletionObserver) deletionObserver.disconnect();
      var pending = null;
      deletionObserver = new MutationObserver(function () {
        if (!finishing) return;
        var hasImage = !!formWrap.querySelector('#teeFormInputs img.tee-photo-image');
        if (!hasImage && !pending) {
          pending = setTimeout(function () {
            pending = null;
            var stillEmpty = !formWrap.querySelector('#teeFormInputs img.tee-photo-image');
            var cropperOpen = !!document.querySelector('.tee-cropper');
            if (stillEmpty && !cropperOpen && finishing) resetToInitial();
          }, 1500);
        } else if (hasImage && pending) {
          clearTimeout(pending); pending = null;
        }
      });
      deletionObserver.observe(formWrap, { childList: true, subtree: true });
    }

    /* On mobile the gallery (with TIB's live preview) sits ABOVE the customizer, so
       land the shopper on the preview instead of the customizer. On desktop (gallery
       beside the customizer) the preview is already visible — leave the scroll alone. */
    function scrollToPreview() {
      var gallery = document.querySelector('.product-gallery');
      if (!gallery) return;
      var stacked = gallery.getBoundingClientRect().bottom <= formWrap.getBoundingClientRect().top + 5;
      if (!stacked) return;
      var offset = 12;
      var headerEl = document.querySelector('.header, header[role="banner"], [role="banner"]');
      if (headerEl) {
        var pos = getComputedStyle(headerEl).position;
        if (pos === 'fixed' || pos === 'sticky') offset += headerEl.getBoundingClientRect().height;
      }
      var y = gallery.getBoundingClientRect().top + window.pageYOffset - offset;
      try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, Math.max(0, y)); }
    }

    // --- wiring ---
    trigger.addEventListener('click', open);
    nextBtn.addEventListener('click', function () {
      if (nextBtn.getAttribute('data-action') === 'finish') { finish(); return; }
      // Details step: don't advance while a required field is still empty.
      if (STEPS[current] && STEPS[current].key === 'details') {
        var bad = firstEmptyRequired();
        if (bad) { try { bad.focus(); } catch (e) {} return; }
      }
      goto(current + 1);
    });
    backBtn.addEventListener('click', function () { goto(current - 1); });
    overlay.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-tib-close')) cancel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) cancel();
    });

    /* ---- Teeinblue cropper orchestration (poll-based) ----
       Step 2: the shopper picks a file -> TIB's cropper opens. The cropper IS step 3:
       we advance to step 3 and lift the cropper above the overlay. Confirming the crop
       closes the cropper AND starts TIB's render -> we finish (pop-up closes, mockup
       renders full-size on the PDP). Cancelling the crop -> back to the upload step. */
    function startCropperWatch() {
      stopWatch();
      var wasOpen = false;
      cropTimer = setInterval(function () {
        var box = document.querySelector('.tee-cropper');
        var present = !!box;

        if (present && !wasOpen) {
          wasOpen = true;
          var cropIdx = stepIndex('crop');
          if (current < cropIdx) goto(cropIdx);         // advance to the crop step
          overlay.classList.add('tib-cropper-hidden');  // let TIB's responsive cropper take over
        }

        if (!present && wasOpen) {
          wasOpen = false;
          overlay.classList.remove('tib-cropper-hidden');
          afterCropperClose();
        }
      }, 200);
    }

    // Teeinblue is uploading/rendering the artwork (progress loader present) — only
    // happens once a crop is confirmed.
    function isRendering() {
      return !!document.querySelector('.tee-photo-uploading, .tee-progress--loading');
    }

    // Cropper closed. If the crop was confirmed (TIB starts rendering / places the
    // cropped image) -> finish. If nothing happened (cancelled) -> back to upload.
    function afterCropperClose() {
      var tries = 0;
      (function check() {
        if (finishing || overlay.hasAttribute('hidden')) return;
        var r = isRendering();
        var placed = !!(formWrap.querySelector('.tee-btn--recustomize') || formWrap.querySelector('#teeFormInputs img.tee-photo-image'));
        if (r || placed) { enterRenderPhase(); return; }        // crop confirmed
        if (++tries > 8) { goto(stepIndex('photo')); return; }  // ~1.6s, nothing -> cancelled crop
        setTimeout(check, 200);
      })();
    }

    /* Crop confirmed: DON'T move the form yet (that would abort TIB's render). Stay
       in step 3 and show TIB's upload/render animation in the panel; finish only once
       the render has completed. */
    function enterRenderPhase() {
      card.setAttribute('data-tib-phase', 'render');
      if (renderTimer) clearInterval(renderTimer);
      var sawLoader = false, elapsed = 0;
      renderTimer = setInterval(function () {
        if (finishing || overlay.hasAttribute('hidden')) { clearInterval(renderTimer); renderTimer = null; return; }
        elapsed += 300;
        var r = isRendering();
        if (r) sawLoader = true;
        if (sawLoader && !r) { clearInterval(renderTimer); renderTimer = null; finish(); return; } // render done
        // no loader ever appeared but the image is placed -> treat as done
        if (!sawLoader && elapsed > 4000 && formWrap.querySelector('.tee-btn--recustomize')) {
          clearInterval(renderTimer); renderTimer = null; finish(); return;
        }
        // hard safety: never hang forever
        if (elapsed > 120000) { clearInterval(renderTimer); renderTimer = null; finish(); return; }
      }, 300);
    }

    render();
  }

  /* ---------- tiny helpers ---------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function waitFor(getter, timeout, cb) {
    var start = Date.now();
    (function poll() {
      var v;
      try { v = getter(); } catch (e) { v = null; }
      if (v) return cb(v);
      if (Date.now() - start > timeout) return cb(null);
      setTimeout(poll, 120);
    })();
  }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
})();
